import { useId } from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { EmployeeType } from 'src/domain/creator';

type Props<T extends FieldValues> = {
    control: Control<T>;
    name: Path<T>;
    disabled?: boolean;
};

export const EmployeeTypeSelect = <T extends FieldValues>({
    control,
    name,
    disabled = false,
}: Props<T>) => {
    const { t } = useTranslation();
    const id = useId();
    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <div>
                    <label htmlFor={id} className="text-sm mb-1.5 block">
                        {t('creators.form.employeeTypeLabel')}
                    </label>
                    <select
                        id={id}
                        name={field.name}
                        ref={field.ref}
                        value={field.value ?? EmployeeType.fullTime}
                        onBlur={field.onBlur}
                        onChange={field.onChange}
                        disabled={disabled}
                        className="text-input w-full"
                    >
                        <option value={EmployeeType.fullTime}>
                            {t('creators.form.employeeTypeFullTime')}
                        </option>
                        <option value={EmployeeType.partTime}>
                            {t('creators.form.employeeTypePartTime')}
                        </option>
                    </select>
                </div>
            )}
        />
    );
};
